import {
  ConcertResponse,
  InternationalEventResponse,
  InternationalEventsMode,
} from 'api/responseTypes';
import { isMiniApp, isSuperQi } from 'utils/miniAppPlatform';

/**
 * Resolve the dashboard-set mode against the current platform:
 * `ALL` everywhere · `WEB` only on web · `SUPER_QI` only on Super QI · `DISABLED` off.
 * When the dashboard hasn't set a mode (undefined), default to web-only.
 */
export const resolveInternationalEventsEnabled = (
  mode: InternationalEventsMode | undefined,
): boolean => {
  switch (mode) {
    case 'ALL':
      return true;
    case 'SUPER_QI':
      return isSuperQi();
    case 'DISABLED':
      return false;
    case 'WEB':
    default:
      return !isMiniApp();
  }
};

/**
 * Adapt an international event to the `ConcertResponse` shape `ConcertCard` expects,
 * so international events can render identically to concerts (used when the backend
 * flags the list as non-compact). `eventKey` carries the numeric id so the card's
 * share link and click resolve to the international detail route. Fields that don't
 * apply to PlatinumList events are filled with inert defaults.
 */
export const internationalEventToConcertCard = (
  event: InternationalEventResponse,
): ConcertResponse => ({
  imageLink: event.imageLink ?? '',
  id: event.id,
  city: event.city ?? '',
  title: event.title,
  subtitle: event.subtitle ?? '',
  date: event.date,
  time: event.time ?? '',
  startingPrice: event.startingPrice,
  currency: event.currency,
  eventId: event.id,
  eventKey: String(event.id),
  state: event.state,
  pricing: [],
  maxAllowedTickets: 0,
  requireAuthentication: false,
  termAndConditions: [],
  hasTimeslots: false,
  parentEventId: null,
});
